export const demonstrationJson = {
    // "title": "Demonstration",
    // "logoPosition": "right",
    "pages": [
        {
            "name": "page1",
            "elements": [
                {
                    "type": "text",
                    "name": "farmerName",
                    "title": "Name of the farmer",
                    "isRequired": true,
                    "placeholder": "Enter"
                },
                {
                    "type": "multipletext",
                    "name": "contactNumber",
                    "title": "Contact Number",
                    "isRequired": true,
                    "items": [
                        {
                            "name": "+91",
                            "placeholder": "Enter",
                            "inputType": "number",
                            "title": "+91",
                            "size": 10,
                            "requiredErrorText": "Error"
                        }
                    ]
                },
                {
                    "type": "text",
                    "name": "villageName",
                    "title": "Village",
                    "isRequired": true,
                    "placeholder": "Enter"
                },
                {
                    "type": "dropdown",
                    "name": "stateName",
                    "title": "State",
                    "isRequired": true,
                    "choices": [
                        //  "Item 1",
                        //  "Item 2",
                        //  "Item 3"
                    ],
                },
                {
                    "type": "dropdown",
                    "name": "districtName",
                    "title": "District",
                    "isRequired": true,
                    "choices": [
                        //  "Item 1",
                        //  "Item 2",
                        //  "Item 3"
                    ],
                },
                {
                    "type": "dropdown",
                    "name": "territoryName",
                    "title": "Territory",
                    "isRequired": true,
                    "choices": [
                        //  "Item 1",
                        //  "Item 2",
                        //  "Item 3"
                    ]
                },
                {
                    "type": "dropdown",
                    "name": "productName",
                    "title": "Product Name",
                    "isRequired": true,
                    "choices": [
                        // "Item 1",
                        // "Item 2",
                        // "Item 3"
                    ]
                },
                {
                    "type": "dropdown",
                    "name": "stageApplication",
                    "title": "Stage of Application",
                    "isRequired": true,
                    "choices": [
                        "Basal",
                        "Vegetative Stage",
                        "Pre - flowering",
                        "Flowering",
                        "Fruit Setting",
                        "Bulb Development",
                        "Tuber Development",
                        "Fruit Development",
                        "Other"
                    ]
                },
                {
                    "type": "file",
                    "name": "uploadPhoto",
                    "title": "Upload Photo",
                    "isRequired": true,
                    "allowMultiple": true,
                    "acceptedTypes": "image/*"
                },
                {
                    "type": "comment",
                    "name": "feedBackName",
                    "title": "Feedback",
                    "isRequired": true,
                    "placeholder": "Enter"
                }
            ]
        }
    ],
    // "navigateToUrl": "https://stag-dms.agrocel.net/#/agrocel/dashboard",
    // "navigateToUrlOnCondition": [
    //  {}
    // ],
    "completeText": "Submit"
}